import React, { useEffect, useState } from 'react';
import { IBasket, IEcProduct } from '@/types/simo/basket';
import './_delivery.scss';
import { getCreditEvaluationStatus } from '@/api/simo';
import { getSessionStorage } from '@/utils/session';
import * as urls from '@/api/urls';
import Button from '@/modules/Button';
import { Redirect } from 'react-router';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { view } from '@nuuday/data-layer';

interface IProps {
  setActiveSection: () => void;
  basket: IBasket;
  checkoutCms: any;
  ecProducts: IEcProduct[];
}

const Delivery = (props: IProps) => {
  const { setActiveSection, basket, ecProducts, checkoutCms } = props;
  const [loading, setLoading] = useState(false);
  const { address } = basket.customerInfo;
  const [fatalError, setFatalError] = useState(false);

  const onContinue = async () => {
    checkCeStatus(0);
  };
  useEffect(() => {
    view({
      pageName: 'delivery',
      siteSection: ['i hjemmet', 'mobil', 'simonly'],
      customEvent: ['ecCheckout'],
      pageType: 'simo checkout 5/8',
      ecProducts,
      mvGrossAdds: ecProducts?.length || 0
    });
  }, []);

  const checkCeStatus = async (counter: number) => {
    const session = getSessionStorage('_session');
    setLoading(true);
    const response = await getCreditEvaluationStatus({ _session: session });
    const { ceid, creditEvaluationIsSuccess } = response;
    if (
      creditEvaluationIsSuccess === 'InProgress' &&
      (counter < 12 || process.env.NODE_ENV !== 'production')
    ) {
      counter = counter + 1;
      setTimeout(() => {
        checkCeStatus(counter);
      }, 5000);
    } else if (creditEvaluationIsSuccess === 'True' || creditEvaluationIsSuccess === 'TimedOut') {
      setLoading(false);
      setActiveSection();
    } else if (creditEvaluationIsSuccess === 'False') {
      window.location.assign(urls.ceDenied.url({ ceid }));
      setLoading(false);
    } else {
      setLoading(false);
      setFatalError(true);
    }
  };

  return (
    <div className="delivery">
      {fatalError && <Redirect to={urls.fatalError.url({ step: 'delivery' })} />}
      <section>
        <p>{documentToReactComponents(checkoutCms.checkoutCms.deliveryText.json)}</p>
        <div className="delivery__address">
          {address && (
            <>
              <div data-hj-suppress>{address.streetAndNumber}</div>
              <div data-hj-suppress>{address.postalCodeAndCity}</div>
            </>
          )}
        </div>

        <div className="delivery__button">
          <Button display="block-centered" value="Fortsæt" onClick={onContinue} loading={loading} />
        </div>
      </section>
    </div>
  );
};

export default Delivery;
